import { useState } from "react";
import { Row, Col, message } from "antd";
import styles from "../../../constants/styles.json";
import Hold from "../../../assets/images/pause-new.svg";
import Cancel from "../../../assets/images/cancel-new.svg";
import CWEstimatePrinter from "../../../lib/printer/CWEstimatePrinter";
import useAdvanceOrderStore from "../../../stores/useAdvanceOrderStore";
import useTransactionStore from "../../../stores/useTransactionStore";

const CartTotalsPanel = ({
  cart,
  pricePrecision,
  currenciesList,
  themeJSON,
  posConfig,
  estimateNo,
  searchInputRef,
  handleUpsertEstimate,
  deleteCart,
  openDisplayParkedBillModal,
  setEstimateNo,
}) => {
  const [isSubmittingEstimate, setIsSubmittingEstimate] = useState(false);

  return (
    <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
      {/* ——— Subtotal / Discount / Tax / Net / Qty section ——— */}
      <div
        style={{
          background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
          height: "23.5vh",
          width: "60%",
          marginRight: "1%",
          border: "1px solid #fff",
          borderRadius: "7px",
          padding: "0.5vh",
          fontSize: "1vw",
          position: "relative",
        }}
      >
        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              textAlign: "left",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Subtotal:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(cart.subTotal).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.4vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Discount:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(cart.discount ? cart.discount : 0).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Tax:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(cart.tax).toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {parseFloat(cart.total)?.toFixed(pricePrecision)}
            </p>
            <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
          </Col>
        </Row>

        <Row style={{ height: "4.5vh" }}>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "0.8vw",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items / Total Qty:</p>
          </Col>
          <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
              }}
            >
              {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
            </p>
          </Col>
        </Row>
      </div>

      {/* ——— Total amount + hold/cancel buttons ——— */}
      <div style={{ height: "23.7vh", width: "40%", fontSize: "1vw" }}>
        <div
          id="sm-cart-total"
          onClick={async () => {
            if (isSubmittingEstimate) return;
            const isAdvanceOrder = useAdvanceOrderStore.getState().isAdvanceOrderEnabled;
            if (posConfig?.enableDeliveryDate === "Y" && isAdvanceOrder && !cart?.deliveryDate) {
              message.warning("Please select a Delivery Date to proceed with the Advance Order.");
              return;
            }
            setIsSubmittingEstimate(true);
            try {
              if (posConfig?.disableOfflineBilling === "Y") {
                await handleUpsertEstimate("PE");
              } else {
                await CWEstimatePrinter(cart);
                deleteCart();
                setEstimateNo((prevEstimateNo) => {
                  const newEstimateNo = prevEstimateNo + 1;
                  localStorage.setItem("estimateNo", newEstimateNo);
                  return newEstimateNo;
                });
                localStorage.removeItem("isB2bEnabled");
                useTransactionStore.getState().setIsB2bEnabled(null);
                localStorage.removeItem("customerAddressIds");
                if (searchInputRef?.current) {
                  searchInputRef.current.focus();
                }
              }
            } finally {
              setIsSubmittingEstimate(false);
            }
          }}
          style={{
            height: "18.2vh",
            position: "relative",
            background: themeJSON.totalAmountToPaySectionBGColor || "#2F3856",
            borderRadius: "7px",
            cursor: isSubmittingEstimate ? "not-allowed" : "pointer",
            pointerEvents: isSubmittingEstimate ? "none" : "auto",
            opacity: isSubmittingEstimate ? 0.6 : 1,
          }}
        >
          <p
            style={{
              padding: "0.7vw 0 0 1vw",
              color: "#fff",
              fontSize: "1em",
              fontWeight: "500",
              height: "4.5vh",
            }}
          >
            Total Amount To Pay
          </p>
          {cart.total !== undefined ? (
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "2.5em",
                fontWeight: "500",
                height: "14.4vh",
                width: "100%",
                alignItems: "flex-start",
                paddingTop: "1.2vh",
              }}
            >
              {" "}
              {parseFloat(cart.total)?.toFixed(pricePrecision)}
            </p>
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "2.5em",
                fontWeight: "500",
                height: "14.4vh",
                width: "100%",
              }}
            >
              {" "}
              0.00
            </p>
          )}
        </div>

        {posConfig?.showEstimates === "Y" ? (
          posConfig?.disableCancelEstimate === "Y" ? (
            <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
              <Col span={24} onClick={() => handleUpsertEstimate("HOLD")}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "500",
                    border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                    height: "4.8vh",
                    borderRadius: "5px",
                    cursor: "pointer",
                    backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                  }}
                >
                  <img src={Hold} style={{ height: "2.5vh" }} />
                  <span
                    style={{
                      margin: "0",
                      color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                      paddingLeft: "0.5vw",
                      fontSize: "1em",
                      fontWeight: 500,
                    }}
                  >
                    Hold
                  </span>
                </div>
              </Col>
            </Row>
          ) : (
            <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
              <Col
                span={12}
                onClick={() => {
                  handleUpsertEstimate("HOLD");
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "500",
                    textAlign: "left",
                    border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                    height: "4.8vh",
                    borderRadius: "5px",
                    cursor: "pointer",
                    backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                  }}
                >
                  <img src={Hold} style={{ height: "2.5vh" }} />
                  <span
                    style={{
                      margin: "0",
                      textAlign: "center",
                      color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                      paddingLeft: "0.5vw",
                      fontSize: "1em",
                      fontWeight: 500,
                    }}
                  >
                    Hold
                  </span>
                </div>
              </Col>
              <Col span={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "500",
                    justifyContent: "center",
                    border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                    height: "4.8vh",
                    borderRadius: "5px",
                    cursor: "pointer",
                    backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                  }}
                  id="sm-delete-cart"
                  onClick={() => {
                    handleUpsertEstimate("CL");
                  }}
                >
                  <img src={Cancel} style={{ height: "2.5vh" }} />
                  <span
                    style={{
                      textAlign: "center",
                      margin: "0",
                      color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                      paddingLeft: "0.5vw",
                      fontSize: "1em",
                      fontWeight: 500,
                    }}
                  >
                    Cancel
                  </span>
                </div>
              </Col>
            </Row>
          )
        ) : (
          <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "500",
                  justifyContent: "center",
                  border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                  height: "4.8vh",
                  borderRadius: "5px",
                  cursor: "pointer",
                  backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                }}
                id="sm-delete-cart"
                onClick={() => {
                  deleteCart();
                  if (searchInputRef?.current) {
                    searchInputRef.current.focus();
                  }
                }}
              >
                <img src={Cancel} style={{ height: "2.5vh" }} />
                <span
                  style={{
                    textAlign: "center",
                    margin: "0",
                    color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                    paddingLeft: "0.5vw",
                    fontSize: "1em",
                    fontWeight: 500,
                  }}
                >
                  Cancel
                </span>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default CartTotalsPanel;
